{
  "titles": {
    "join": "Rejoindre {{fboName}}",
    "invalidInvite": "Invitation non valide"
  },
  "messages": {
    "joinQuestion": "Voulez-vous rejoindre {{fboName}} sur AirPlx ?",
    "alreadyClaimed": "Vous avez déjà utilisé votre invitation. Vous pouvez maintenant accéder à votre compte sur app.airplx.com. Nous vous recommandons d'ajouter ce lien à vos favoris pour y accéder rapidement."
  },
  "buttons": {
    "no": "Non",
    "yes": "Oui",
    "ok": "Ok"
  }
}
